import { Flex, FormControl, FormErrorMessage, Radio, RadioGroup, RadioGroupProps, Stack } from '@chakra-ui/react';
import { Controller, useFormContext } from 'react-hook-form';

import { FormLabel } from './FormLabel';

export const FormRadioGroup = ({
    fieldName,
    label,
    options,
    isRequired = false,
    isReadOnly,
    labelWidth,
    ...radioGroupProps
}: {
    fieldName: string;
    label: string;
    options: { label: string; value: string }[];
    isRequired?: boolean;
    isReadOnly?: boolean;
    labelWidth?: string;
} & Omit<RadioGroupProps, 'children'>) => {
    const {
        formState: { errors },
    } = useFormContext();

    return (
        <FormControl
            isInvalid={!!errors[fieldName]}
            isRequired={isRequired}
            pointerEvents={isReadOnly ? 'none' : 'initial'}
        >
            <Flex direction="row" align="center">
                <FormLabel fieldName={fieldName} labelWidth={labelWidth} label={label} />
                <Controller
                    name={fieldName}
                    render={({ field: { onChange, value } }) => (
                        <RadioGroup
                            id={fieldName}
                            {...radioGroupProps}
                            value={value}
                            onChange={onChange}
                            isReadOnly={isReadOnly}
                        >
                            <Stack spacing={4} direction="row">
                                {options.map((option) => (
                                    <Radio key={option.value} colorScheme="teal" value={option.value}>
                                        {option.label}
                                    </Radio>
                                ))}
                            </Stack>
                        </RadioGroup>
                    )}
                />
            </Flex>
            {errors[fieldName] && <FormErrorMessage>{String(errors[fieldName]?.message)}</FormErrorMessage>}
        </FormControl>
    );
};
